export default "__VITE_PUBLIC_ASSET__2d8be171__"